module.exports = __webpack_public_path__ + "img/scene_3.7e5962c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/theme/assets/offline/scene_3.png
// module id = ./assets/theme/assets/offline/scene_3.png
// module chunks = 152